export const PADDING = {
  CARD_HEADER: '1.3rem 1rem',
  CARD_ROW: '1rem',
  CARD_ROW_LR: '1rem',
  INPUT_LR: '0.5rem',
  FORM: '2rem',
  FORM_NARROW: '1rem',
};
